// extracted by mini-css-extract-plugin
export default {"container":"FeatureCard_container__40+OB","container_noborders":"FeatureCard_container_noborders__4sDIs","gradient-animation":"FeatureCard_gradient-animation__ektcl"};